/**
 * Keep body copy on the marketing site in sentence case.
 * Heading transform and weight come from createTheme (h1, h2, h4 uppercase).
 */
export const globalStyles = {
  p: {
    fontWeight: 'normal',
    textTransform: 'none' as const,
    letterSpacing: 'normal',
  },
}
